<template>
    <div class="flex flex-col">
        <div class="flex flex-row gap-2 items-baseline">
            <div
                class="border rounded border-gray-400 px-3 md:px-4 py-2.5 text-xs text-center"
                :class="(page === i) ? 'bg-blue-700 text-white' : 'bg-white text-blue-700 cursor-pointer'"
                v-for="i in [...Array(Math.ceil(count/limit))].map((e, i) => i + 1)"
                v-show="i === 1 || i === Math.ceil(count/limit) || ((page-3)<i && (page+3)>i)"
                @click="paginate(i)"
            >{{ i }}</div>
            <div class="text-sm text-gray-600">Всего: {{count}}</div>
        </div>
    </div>

</template>

<script>

export default {
    props: {
        count: {
            type: Number,
            default: 1,
        },
        page: {
            type: Number,
            default: 1,
        },
        limit: {
            type: Number,
            default: 1,
        },
        paginate: {
            type: Function,
            default: (i) => alert(`paginate offset=${i}`),
        }
    },
}
</script>
